import Vue from "vue";
import { Button, Select, Container, Header, Footer } from "element-ui";

Vue.use(Button);
Vue.use(Select);
Vue.use(Container);
Vue.use(Header);
Vue.use(Footer);
